import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { ClinButton } from '../../components/ClinButton'
import { mediaQueryDown } from '../../utils/mediaQuery'

interface IStyledFixedWidthContainerProps {
  width?: number
}

const desktopUpBreakpoint = ClinTheme.breakpoints[2]

export const StyledCheckoutDrawer = styled.div({
  padding: `0 ${ClinTheme.space[5]}px`,
  height: 'calc(100% - 48px)',
  overflow: 'auto',
  [`.clin-announce`]: {
    marginBottom: ClinTheme.space[3]
  }
})

export const StyledDrawerHeader = styled.div({
  marginBottom: ClinTheme.space[3]
})

export const StyledDrawerBody = styled.div({
  marginBottom: ClinTheme.space[5]
})

export const StyledClinButton = styled(ClinButton)({
  fontSize: ClinTheme.fontSizes[2],
  color: ClinTheme.colors.black
})

export const StyledSpinnerContainer = styled.div({
  display: 'flex',
  height: '50vh',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '16px'
})

export const StyledClinPrimaryButton2 = styled(ClinButton)({
  fontSize: ClinTheme.fontSizes[2],
  paddingRight: ClinTheme.space[4],
  paddingLeft: ClinTheme.space[4],
  letterSpacing: 0,
  flex: '1 1 auto',
  maxWidth: '100%'
})

export const StyledLoadingContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  flex: '1 1 auto',
  [mediaQueryDown(desktopUpBreakpoint)]: {
    flex: '1 1 50%'
  }
})

export const StyledLoadingSpinner = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginLeft: ClinTheme.space[2]
})

export const StyledRow = styled.div({
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap',
  alignItems: 'baseline'
})

export const StyledColumn = styled.div<IStyledFixedWidthContainerProps>(
  (props) => ({
    flex: '0 0 auto',
    width: props.width ? `${props.width}px` : '100%',

    [mediaQueryDown(desktopUpBreakpoint)]: {
      flex: '1 1 100%',
      width: '100%'
    }
  })
)
